import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const {
	ACCOUNT: { PURCHASES_COMPLETE },
} = ANALYTICS_CATEGORIES;

export const triggerUndoDeliveryStatusAnalyticsEvent = (enquiryId: number): void => {
	const eventPayload = getSnowplowEventPayload({
		category: PURCHASES_COMPLETE,
		customData: { label: enquiryId },
		name: `dlr_vehicle_delivery_undo_delivery`,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
